import styled from 'styled-components'

export const Container = styled.div`
	margin: 36px 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 70vh;
	flex-direction: column;

	.card {
		width: 100%;
		max-width: 800px;

		> h1 {
			grid-column: 1/span 2;
			margin: 0 8px;
		}

		.table-container {
			margin-bottom: 20px;
		}

		a {
			grid-column: 1/span 2;
			color: #FFF;
		}
	}
	
	form {
		display: grid;
		grid-template-columns: 1fr 2fr;

		button {
			justify-self: flex-end;
			grid-column: 1/span 2;
			margin-top: 12px;
		}

		@media(max-width: 600px) {
			display: flex;
			flex-direction: column;
		}
	}

	@media(max-width: 600px) {
		margin: 0 0 40px;

		.card {
			width: 100%;
		}
	}
`
